module.exports = __webpack_public_path__ + "img/snack-empty.c3cf2832.svg";